import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISiteSAMLAttributeMapping } from '../types/ISiteSAMLConfiguration';

export class SetSiteAttributeMappingRequest extends Request<ISiteSAMLAttributeMapping, IResult> {
  constructor(mapping: ISiteSAMLAttributeMapping) {
    super('setSiteAttributeMapping', mapping);
  }
}
